import classnames from 'classnames';
import React, { useEffect } from 'react';

export interface ModalProps {
  heading?: string;
  showCloseIcon?: boolean;
  children: React.ReactNode;
  backdropColor?: string;
  closeModal: () => void;
  maxWidth?: string;
  noPadding?: boolean;
  className?: string;
  altCloseIcon?: boolean;
  zIndex?: string;
  isOverlayOnClick?: boolean;
  overlay?: string;
}

const Modal: React.FC<ModalProps> = ({
  children,
  closeModal,
  overlay = 'bg-black opacity-90',
  className = '',
  zIndex = '',
  isOverlayOnClick = true,
}) => {
  useEffect(() => {
    document.body.style.height = '100%';
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.height = null;
      document.body.style.overflow = null;
    };
  }, []);

  return (
    <div
      className={classnames('fixed inset-0 overflow-y-auto', {
        'z-10': !zIndex,
        [zIndex]: zIndex,
      })}
    >
      <div className="bg-white h-full w-full flex justify-center items-center">
        <div className="fixed inset-0 transition-opacity">
          <div
            className={`absolute inset-0 ${overlay}`}
            onClick={() => {
              isOverlayOnClick && closeModal();
            }}
          ></div>
        </div>
        <div className={`transform transition-all ${className}`}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
